export default function menubar() {
  // Menu
  $(document).ready(function() {

    let menuOpen = false;

    $('.menu-icon').click(function() {

      if (menuOpen) {
        $('#menu-overlay').addClass('hide');
        $('#menu-overlay').removeClass('show');
        menuOpen = false;

      }
      else {
        $('#menu-overlay').addClass('show');
        $('#menu-overlay').removeClass('hide');
        menuOpen = true;
      }

    });

  });
}
